import { Fragment } from "react";
import clsx from "clsx";
import NewsCard from "components/organism/Cards/NewsCard";
import { newsList } from "data";
import {useState} from "react";

const LatestArticles = () => {
    const [load, setLoad] = useState(false);
    return (
        <Fragment>
            <section className={clsx(
                "w-full max-w-[1440px] mx-auto",
                "px-6 tablet:px-8 desktop:px-[120px] phone:pb-[48px] tablet:pb-[72px] pb-[96px]"
            )}>
                <h1 className="font-semibold text-heading-3 tablet:text-heading-4 phone:text-heading-5 text-neutral-100">Latest Articles</h1>
                <div className="w-full grid grid-cols-1 tablet:grid-cols-3 desktop:grid-cols-3 phone:gap-10 gap-12 tablet:mt-8 mt-10 phone:mt-6">
                    {newsList.map((item) => (
                        <NewsCard key={item.id} title={item.title} image={item.image} author={item.author} dateposted={item.dateposted} />
                    ))}
                    {load ? newsList.slice(0, 4).map((item) => (
                        <NewsCard key={item.id} title={item.title} image={item.image} author={item.author} dateposted={item.dateposted} />
                    )) : ""}
                </div>
                {load ? "" : (
                    <div className="mt-[72px] phone:mt-[56px] tablet:mt-16 text-center">
                        <button onClick={() => setLoad(true)} className="py-[18px] phone:w-full h-[56px] flex items-center mx-auto justify-center leading-[19.83px] px-[33px] bg-primary-surface rounded-lg text-primary-main font-semibold text-md">Load More Article</button>
                    </div>
                )}
            </section>
        </Fragment >
    );
};

export default LatestArticles;